import { useState, useEffect } from 'react';
import { botWalletApi } from '@/utils/api';

export const BotWalletPanel = () => {
    const [stats, setStats] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    const fetchStats = () => {
        setLoading(true);
        botWalletApi.getStats()
            .then(res => res.json())
            .then(data => { if (data.success) setStats(data.wallet); })
            .catch(console.error)
            .finally(() => setLoading(false));
    };

    useEffect(() => { fetchStats(); }, []);

    return (
        <div className="space-y-6">
            <h2 className="text-xl font-bold text-white uppercase tracking-widest">Platform Fee Wallet</h2>
            {loading ? (
                <div className="text-white/40">Loading stats...</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="p-6 rounded-2xl bg-[#0A0E17] border border-white/5">
                        <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">Available Balance</span>
                        <div className="flex items-end gap-2 mt-2">
                            <h3 className="text-3xl font-black text-white">{Number(stats?.available_balance || 0).toFixed(2)}</h3>
                            <span className="text-sm font-bold text-blue-500 mb-1">GRAM</span>
                        </div>
                    </div>
                    <div className="p-6 rounded-2xl bg-[#0A0E17] border border-white/5">
                        <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">Total Fees Collected</span>
                        <div className="flex items-end gap-2 mt-2">
                            <h3 className="text-3xl font-black text-green-400">{Number(stats?.total_fees || 0).toFixed(2)}</h3>
                            <span className="text-sm font-bold text-green-500/50 mb-1">GRAM</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
